import Thumbnail from './Thumbnail.vue';
import Empty from './Empty.vue';
import NavigationBar from './NavigationBar.vue';
import Content from './Content.vue';
import Video from './Video.vue';
import AppShare from './AppShare.vue';
import Swipe from './Swipe.vue';
import SwipeItem from './SwipeItem.vue';
import DownloadHang from './DownloadHang.vue';
import Star from './Star.vue';
import PostContent from './PostContent.vue';
const components = {
  Thumbnail,
  Empty,
  NavigationBar,
  Content,
  Swipe,
  SwipeItem,
  Video,
  AppShare,
  DownloadHang,
  Star,
  PostContent,
};
const prefix = 'Zeeho';
const install = function install(Vue) {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    const componentName = prefix + key;
    Vue.component(componentName, components[key]);
  });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: process.env.VERSION, // eslint-disable-line no-undef

  install,
  ...components,
};
